// Audit Trail: the routes and the sidebar rows of `wealth.compliance.audit-trail` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.audit-trail',
    routes: [
        {
            frontend: 'comply',
            path: 'audit-trail',
            lazy: () => import('@/pages/comply/audit-trail/page'),
        },
        {
            // The Admin shell shows the same audit trail. The endpoint admits
            // `comply` and `admin`.
            frontend: 'admin',
            path: 'audit-log',
            lazy: () => import('@/pages/comply/audit-trail/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'audit-trail',
            label: 'Audit Trail',
            href: '/comply/audit-trail',
            icon: 'ScrollText',
            group: 'monitoring',
            order: 450,
        },
        {
            frontend: 'admin',
            key: 'audit-log',
            label: 'Audit Log',
            href: '/admin/audit-log',
            icon: 'ScrollText',
            group: 'audit-access',
            order: 600,
        },
    ],
});
